/**
 * normalizeKeys - Convierte las claves de un objeto/array a minúsculas.
 * Necesario porque SQL Server devuelve columnas capitalizadas (Id, Nombre, etc.)
 * pero el frontend espera claves en minúsculas (id, nombre, etc.)
 */
export function normalizeKeys(obj) {
    if (!obj || typeof obj !== 'object') return obj;
    if (Array.isArray(obj)) return obj.map(normalizeKeys);
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
        result[key.toLowerCase()] = value;
    }
    return result;
}

/**
 * normalizeKeysDeep - Igual que normalizeKeys pero también normaliza objetos anidados
 */
export function normalizeKeysDeep(obj) {
    if (!obj || typeof obj !== 'object') return obj;
    if (Array.isArray(obj)) return obj.map(normalizeKeysDeep);
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
        result[key.toLowerCase()] = (value && typeof value === 'object') ? normalizeKeysDeep(value) : value;
    }
    return result;
}

/**
 * camelToSnake - Convierte camelCase a snake_case
 * Ej: "idModulo" → "id_modulo", "tipoProceso" → "tipo_proceso"
 */
function camelToSnake(str) {
    return str
        .replace(/([A-Z])/g, '_$1')
        .replace(/(\d+)/g, '_$1')
        .toLowerCase()
        .replace(/^_/, '')
        .replace(/__+/g, '_');
}

/**
 * normalizeResponse - Normaliza respuesta de API (camelCase o PascalCase → snake_case)
 * Maneja tanto "Id_Modulo" (PascalCase_Underscore) como "idModulo" (camelCase)
 */
export function normalizeResponse(obj) {
    if (!obj || typeof obj !== 'object') return obj;
    if (Array.isArray(obj)) return obj.map(normalizeResponse);
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
        // Si tiene underscores (SQL style), solo lowercase
        // Si es camelCase, convertir a snake_case
        const newKey = key.includes('_') ? key.toLowerCase() : camelToSnake(key);
        result[newKey] = (value && typeof value === 'object') ? normalizeResponse(value) : value;
    }
    return result;
}
